<script>
	import { createEventDispatcher } from 'svelte'
	import { getTask } from '../track/_core'
	import { css } from '../../node_modules/@emotion/css/dist/emotion-css.umd.min.js'
	import CompletionCriteria from './CompletionCriteria.svelte'

	export let open = false
	export let loading = false
	export let error = false
	export let sucessMsg = ''

	let code, preSubError, completionCriteria, confirmCancelTask

	const dispatch = createEventDispatcher()

	const close = () => {
		dispatch('close')
	}

	const submitCode = code => {
		dispatch('submitcode', { code })
	}

	const submit = () => {
		if (!code)
			preSubError = 'Missing required code'
		else {
			submitCode(code)
			preSubError = ''
		}
	}

	const claimReward = () => {
		dispatch('claimreward')
	}

	const cancelTask = () => {
		if (confirmCancelTask) {
			confirmCancelTask = false
			dispatch('canceltask')
		} else
			confirmCancelTask = true
	}

	$: {
		if (open) {
			preSubError = ''
			code = ''
			confirmCancelTask = false
			completionCriteria = (getTask()||{}).completionCriteria
			// completionCriteria = [{
			// 	id: 1,
			// 	description: 'Browse to http://localhost:8080/tester',
			// 	type: 'browse',
			// 	completed: true,
			// 	url: 'http://localhost:8080/tester'
			// }, {
			// 	id: 2,
			// 	description: 'Scroll to the "My Section" section',
			// 	type: 'scroll',
			// 	completed: true,
			// 	cssSelector: '#my-section'
			// }, {
			// 	id: 3,
			// 	description: 'Wait for at least 10 seconds',
			// 	type: 'wait',
			// 	completed: true,
			// 	duration: 10000
			// }, {
			// 	id: 4,
			// 	description: 'Click on the "Click me" button',
			// 	type: 'click',
			// 	completed: true,
			// 	cssSelector: '#hello'
			// }]
		}
	}

	$: displayError = error || preSubError
	$: showTaskProgress = completionCriteria && completionCriteria.length
	$: canFinalize = showTaskProgress && completionCriteria.every(x => x.completed)

	const mocalCss = css(`
		--primary: #1876D1;
		--danger: #f05f5f;
		--success: #04aa58;
		
		& * {
			font-family: Arial, sans-serif;
		}

		@keyframes refresh-icon-spin {
			from {
				transform:rotate(0deg);
			}
			to {
				transform:rotate(360deg);
			}
		}

		& .refresh-spinner {
			animation-name: refresh-icon-spin;
			animation-duration: 1000ms;
			animation-iteration-count: infinite;
			animation-timing-function: linear;
		}

		& .prevent-select {
			-webkit-user-select: none; /* Safari */
			-ms-user-select: none; /* IE 10 and IE 11 */
			user-select: none; /* Standard syntax */
		}

		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		z-index: 9998;
		display: flex;
		align-items: center;
		justify-content: center;

		& .uxmagic-modal-backround {
			position: fixed;
			top: 0;
			left: 0;
			width: 100vw;
			height: 100vh;
			background-color: black;
			transition: opacity 100ms ease-out;
			-webkit-transition: opacity 100ms ease-out;
			-moz-transition: opacity 100ms ease-out;
			-o-transition: opacity 100ms ease-out;
			opacity: 0;
		}

		&.show {
			& .uxmagic-modal-backround {
				opacity: 0.3;
				visibility: visible;
			}
		}

		&.hide {
			& .uxmagic-modal-backround
				opacity: 0;
				visibility: hidden;
			}
		}

		& .uxmagic-modal {
			z-index: 9999;
			width: 90%;
			max-width: 600px;
			height: 300px;
			background-color: white;
			border-radius: 20px;

			& .uxmagic-modal-container {
				display: grid;
				grid-template-rows: 210px 50px;
				padding: 25px;

				& .uxmagic-body {
					& .success-msg {
						line-height: 24px;
						height: 90%;
						display: flex;
						align-items: center;
						justify-content: center;
						color: var(--primary);
					}

					& .uxmagic-confirm-cancel {
						display: flex;
						align-items: center;
						justify-content: center;
						height: 70%;
					}
				}

				& .code-input-block {
					height: 80px;
				}

				& .code-input {
					border: 1px solid #c4c4c4;
					border-radius: 8px;
					height: 40px;
					display: flex;
					align-items: center;

					& input {
						width: 100%;
						border: 0;
						margin-left: 10px;
						font-size: 20px;
						font-family: 'Courier New', monospace;
						background-color: #00000000;

						&:focus-visible {
							outline: none;
						}
					}
				}

				& .code-input-msg {
					margin-top: 7px;
					font-size: 14px;
					font-style: italic;
				}

				& .code-input-block-error {
					& .code-input {
						border: 1px solid var(--danger);
					}

					& .code-input-msg {
						color: var(--danger);
					}
				}

				& .uxmagic-modal-buttons {
					display: flex;
					justify-content: flex-end;

					& .button {
						border-radius: 6px;
						cursor: pointer;
						height: 40px;
						width: 100px;
						display: flex;
						align-items: center;
						justify-content: center;
						margin-left: 10px;
					}

					& .uxmagic-modal-cancel {
						background-color: white;
						border: 1px solid var(--danger);
						color: var(--danger);
					}

					& .uxmagic-modal-cancel-task {
						background-color: var(--danger);
						border: 1px solid var(--danger);
						color: white;
						width: 130px;
						white-space: nowrap;
					}

					& .uxmagic-modal-submit {
						background-color: var(--primary);
						border: 1px solid var(--primary);
						color: white;

						& .uxmagic-submit-label {
							display: block;
							white-space: nowrap;
						}

						& .uxmagic-spinner {
							display: none;
							width: 28px;

							& svg {
								width: 28px;
							}
						}

						&.loading {
							& .uxmagic-submit-label {
								display: none;
							}

							& .uxmagic-spinner {
								display: flex;
								align-items: center;
								justify-content: center;
							}
						}

						&.uxmagic-reward {
							width: 145px;
						}
					}
				}
			}
		}
	`)
</script>

<div class={`${mocalCss} ${open?'show':'hide'}`} on:click={close}>
	<div class="uxmagic-modal-backround">
	</div>
	<div class="uxmagic-modal" on:click|stopPropagation={() => null}>
		<div class="uxmagic-modal-container">
			<div class="uxmagic-body">
			{#if showTaskProgress}
				{#if confirmCancelTask}
				<div class="uxmagic-confirm-cancel">Please confirm you want to cancel this task?</div>
				{:else}
				<CompletionCriteria completionCriteria={completionCriteria} error={displayError}/>
				{/if}
			{:else}
				{#if sucessMsg}
					<div class="success-msg">{@html sucessMsg}</div>
				{:else}
					<p>Enter your code to start your task</p>
					<div class={`code-input-block ${displayError ? 'code-input-block-error' : ''}`}>
						<div class="code-input">
							<input type="text" bind:value={code}/>
						</div>	{#if displayError}
						<div class="code-input-msg">
							{displayError}
						</div>{/if}
					</div>
				{/if}
			{/if}
			</div>
			<div class="uxmagic-modal-buttons">
				<div class="uxmagic-modal-cancel button prevent-select" on:click={close}>
					{#if sucessMsg || showTaskProgress}
						Close
					{:else}
						Cancel
					{/if}
				</div>
				{#if !sucessMsg}
					{#if (!showTaskProgress || canFinalize)}
					<div 
						class={`uxmagic-modal-submit button prevent-select ${loading ? 'loading' : ''} ${canFinalize ? 'uxmagic-reward' : ''}`} 
						on:click={canFinalize ? claimReward : submit}>
						<div class="uxmagic-submit-label">{canFinalize ? 'Claim reward' : 'Submit'}</div>
						<div class="uxmagic-spinner refresh-spinner">
							<svg fill="white" class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="RefreshIcon"><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13"></path></svg>
						</div>
					</div>
					{/if}
				{/if}
				{#if (showTaskProgress && !canFinalize)}
				<div class="uxmagic-modal-cancel-task button prevent-select" on:click={cancelTask}>
					{#if confirmCancelTask}
						Confirm
					{:else}
						Cancel task
					{/if}
				</div>
				{/if}
			</div>
		</div>		
	</div>
</div>
